import React, { Component } from 'react';

import  PanelLayout  from "../layout/panel-layout";
import { BootstrapTable , TableHeaderColumn  } from 'react-bootstrap-table';
import { Link } from "react-router-dom";
import PatientPartial from "../partials/patient";
import {history} from '../../helpers/history';
import { requestState } from "../../constants/enum.constants";
import { dateDataFormatter,enumDataFormatter,nestadDataFormatter,rightAlignStyle } from "../../helpers/table-formatter";

function buttonFormatter(cell, row) {
    return (
      <div>
          
          <Link to={`/showcertrequest/${cell}`} className="btn btn-default btn-sm"><i className="fa fa-eye"></i> نمایش
           </Link>
      </div>
    );
  }

class PatientCertRequest extends React.Component {
    
    
    constructor(props) {
        super(props);
        this.state = { 
                    
        };
       
        this.handlebackClick=this.handlebackClick.bind(this);

    
    }

    handlebackClick()
    {
        history.goBack();
    }


    componentWillReceiveProps(newProps)
    {
      
        const {model}=newProps;
        
        
        if(model)
        {
            this.setState({

                patient:model,    
            });
        }
       
       
        
      
    }
    
   

    render() { 
        //const {model} = this.props;

        
        const {_model,patient}= this.state;
        const {loading,error} = this.props;
        const model=_model;    

        return ( 

        <PanelLayout title={"لیست درخواست گواهی"}>

            <div className="panel-body custom">

            <div className="panel panel-default">
               
                <div className="toolbox">

                    <button type="button"  className="btn btn-default btn-sm" onClick={this.handlebackClick} ><i className="fa fa-arrow-right"></i>   بازگشت
                            
                    </button>

                    &nbsp;

                    <Link to={`/certrequest/new/${patient && patient.Id}`} className="btn btn-primary btn-sm"><i className="fa fa-file"></i> گواهی جدید
                    </Link>
                
                </div>
            </div>

            <PatientPartial patient={patient}></PatientPartial>
                
            
            <div class="panel panel-default">
                <div class="panel-heading">لیست درخواست ها</div>
                <div class="panel-body">
                   
                <BootstrapTable data={patient && patient.CertificationRequests}  striped hover
                                headerContainerClass='rightAlignStyle'
                                bodyContainerClass='rightAlignStyle'
                                  
                            >
                                <TableHeaderColumn isKey dataField='Id' hidden >id</TableHeaderColumn>
                                <TableHeaderColumn dataField='UniqueNo'  thStyle={{textAlign:"right"}} tdStyle={{textAlign:"right"}}   >شماره گواهی</TableHeaderColumn>
                                <TableHeaderColumn dataField='CertificationType' formatExtraData="Title" thStyle={{textAlign:"right"}} tdStyle={{textAlign:"right"}} dataFormat={ nestadDataFormatter }  >نوع گواهی</TableHeaderColumn>
                                <TableHeaderColumn dataField='Physician' formatExtraData="FullName" thStyle={{textAlign:"right"}} tdStyle={{textAlign:"right"}} dataFormat={ nestadDataFormatter }  >پزشک</TableHeaderColumn>
                                <TableHeaderColumn dataField='CertificationReference' formatExtraData="Title" thStyle={{textAlign:"right"}} tdStyle={{textAlign:"right"}} dataFormat={ nestadDataFormatter }  >مرجع</TableHeaderColumn>
                                <TableHeaderColumn dataField='RequestDate' thStyle={{textAlign:"right"}} tdStyle={{textAlign:"right"}} dataFormat={ dateDataFormatter }  >تاریخ</TableHeaderColumn>
                                <TableHeaderColumn dataField='RequestState' thStyle={{textAlign:"right"}} tdStyle={{textAlign:"right"}} dataFormat={ enumDataFormatter } formatExtraData={ requestState} >وضعیت</TableHeaderColumn>
                                <TableHeaderColumn dataField='Id' thStyle={{textAlign:"right"}} tdStyle={{textAlign:"right"}} dataFormat={ buttonFormatter }></TableHeaderColumn>
                            </BootstrapTable>
                
                </div>
            </div>
               
            </div>
        </PanelLayout>





        );
    }
}

 
export default PatientCertRequest;